import {
  defaultFooterData,
  defaultFooterLegalLinks,
  type FooterV4Props,
} from '@jouzen/ecom-components/layout';
import { useGateValue } from '@statsig/react-bindings';
import noop from 'lodash/noop';
import { type MouseEvent, useState } from 'react';

import useUsaOnly from '@/app/hooks/useUsaOnly';

export interface UseFooterPropsOptions {
  currentPath: string;
  locale: string;
  onFooterLinkClick: (
    event: MouseEvent<HTMLAnchorElement>,
    analyticCta: string,
  ) => void;
  onLanguageSwitcherClick: () => void;
  onLocaleChange: (locale: string) => void;
  parentFooterProps?: Partial<FooterV4Props> | undefined;
  sendEmailSubmitAnalytics: (email: string) => Promise<void>;
}

const useFooterProps = ({
  currentPath,
  locale,
  onFooterLinkClick,
  onLanguageSwitcherClick,
  onLocaleChange,
  parentFooterProps,
  sendEmailSubmitAnalytics,
}: UseFooterPropsOptions): FooterV4Props => {
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const isEU = useGateValue('is_european_union');
  const isUS = useUsaOnly();
  const isForOrganizationsEnabled = useGateValue('for_organizations_enabled');

  const handleNewsletterFormSubmit = (email: string): void => {
    void sendEmailSubmitAnalytics(email).catch(noop);
    if (email) setEmailSubmitted(true);
  };

  return {
    currentPath,
    emailSubmitted,
    legalLinks: defaultFooterLegalLinks({ isEU, isUS }),
    linkGroups: defaultFooterData({ isForOrganizationsEnabled }),
    onLinkClick: onFooterLinkClick,
    onLocalePickerClick: onLanguageSwitcherClick,
    onLocaleChange: onLocaleChange,
    onNewsletterFormSubmit: handleNewsletterFormSubmit,
    selectedLocale: locale,
    showImpressum: isEU,
    ...parentFooterProps,
  };
};

export default useFooterProps;
